var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1200pt",
    height: "1200pt",
    viewBox: "0 0 1200 1200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m600 0c-159.13 0-311.74 63.215-424.27 175.73-112.52 112.52-175.73 265.14-175.73 424.27s63.215 311.74 175.73 424.27c112.52 112.52 265.14 175.73 424.27 175.73s311.74-63.215 424.27-175.73c112.52-112.52 175.73-265.14 175.73-424.27s-63.215-311.74-175.73-424.27c-112.52-112.52-265.14-175.73-424.27-175.73zm0 1107.7c-134.65 0-263.78-53.488-358.99-148.7-95.211-95.211-148.7-224.34-148.7-358.99s53.488-263.78 148.7-358.99c95.211-95.211 224.34-148.7 358.99-148.7s263.78 53.488 358.99 148.7c95.211 95.211 148.7 224.34 148.7 358.99s-53.488 263.78-148.7 358.99c-95.211 95.211-224.34 148.7-358.99 148.7zm230.77-334.62v0.003906c0 15.301-6.0781 29.973-16.898 40.793-10.82 10.82-25.492 16.898-40.793 16.898h-346.16c-15.301 0-29.973-6.0781-40.793-16.898-10.82-10.82-16.898-25.492-16.898-40.793v-346.16c0-15.301 6.0781-29.973 16.898-40.793 10.82-10.82 25.492-16.898 40.793-16.898h346.16c15.301 0 29.973 6.0781 40.793 16.898 10.82 10.82 16.898 25.492 16.898 40.793z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStop);
export default __webpack_public_path__ + "static/media/stop.dc9fa8c109f0682317ee41fd8117ccff.svg";
export { ForwardRef as ReactComponent };